var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { Component } from "react";
import Loading from "@irati/ui/src/Loading";
import { H4 } from "@irati/ui/src/Headings";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import Flex from "@irati/ui/src/Flex";
import { IconButton } from "@irati/ui/src/Button";
import EditFailedUser from "../../../components/Users/EditFailedUser/EditFailedUser";
import { ValidationButton, Wrapper, MarginTop, H2FlexGrow } from "./styled";
var AddPeopleFailed = /** @class */ (function (_super) {
    __extends(AddPeopleFailed, _super);
    function AddPeopleFailed() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            load: null
        };
        _this.removeUser = function (user) {
            var _a = _this.props, added = _a.added, notAdded = _a.notAdded, removeUser = _a.removeUser, gotoSuccess = _a.gotoSuccess;
            removeUser(user, function () {
                if (notAdded.length === 0) {
                    gotoSuccess(added.length);
                }
            });
        };
        _this.submitFailedUsers = function () {
            var _a = _this.props, notAdded = _a.notAdded, added = _a.added, handleCreate = _a.handleCreate, gotoSuccess = _a.gotoSuccess;
            var adding = __spreadArrays(notAdded).map(function (user) { return handleCreate(user); });
            var load = Promise.all(adding).then(function () {
                if (notAdded.length === 0) {
                    gotoSuccess(added.length);
                }
            });
            _this.setState({ load: load });
        };
        return _this;
    }
    AddPeopleFailed.prototype.render = function () {
        var _this = this;
        var load = this.state.load;
        var _a = this.props, notAdded = _a.notAdded, added = _a.added, headers = _a.headers, formatMessage = _a.formatMessage, back = _a.back;
        var notAddedLength = notAdded.length;
        var addedLength = added.length;
        return (React.createElement(Wrapper, null,
            React.createElement(Loading, { load: load },
                React.createElement(Flex, { alignItems: "center", margin: "0 0 30px 0" },
                    back && React.createElement(IconButton, { onClick: back, icon: "backArrow" }),
                    React.createElement(H2FlexGrow, { className: "flush--top push--bottom center" },
                        React.createElement(FormattedMessage, { id: "admin.containers.addPeopleFailed.headingTwo.notAdded.text", values: { notAddedLength: notAddedLength } }))),
                added.length >= 1 &&
                    React.createElement(H4, { className: "center flush--top push--bottom" },
                        React.createElement(FormattedMessage, { id: "admin.containers.addPeopleFailed.headingTwo.added.text", values: { addedLength: addedLength } })),
                React.createElement(MarginTop, null, notAdded.map(function (user) { return (React.createElement(EditFailedUser, { key: user.email, user: user, removeUser: _this.removeUser, headers: headers })); }))),
            React.createElement(ValidationButton, { primary: true, large: true, load: load, loading: formatMessage({ id: "admin.containers.addPeopleFailed.validationButton.loading" }, { notAddedLength: notAddedLength }), onClick: this.submitFailedUsers },
                React.createElement(FormattedMessage, { id: "admin.containers.addPeopleFailed.validationButton.text" }))));
    };
    return AddPeopleFailed;
}(Component));
export default injectIntl(AddPeopleFailed);
